
import { Drawer } from "element-ui"
import drawerHeader from "./drawer/components/drawerHeader.vue"
import { base64Decode } from "@/utils/utils"

export default {
  components: {
    [Drawer.name]: Drawer,
    drawerHeader
  },
  data() {
    return {
      loading: false,
      cardList: [],
      visible: false,
      processInstance: null
    }
  },
  created() {
    this.initPaymentSDK()
    this.getCardList()
  },
  destroyed() {
    console.log(this.$sdk)
  },
  methods: {
    _formatCardNumber(cardNumber, separator = " ") {
      // 每4位分割
      const groups = []
      for (let i = 0; i < cardNumber.length; i += 4) {
        groups.push(cardNumber.slice(i, i + 4))
      }
      // 使用分隔符连接
      return groups.join(separator)
    },
    initStatus() {
      if (this.processInstance) {
        this.processInstance.destroy()
      }
    },
    async initPaymentSDK() {
      try {
        this.paymentMethod = await this.$sdk.init()
      } catch (error) {
        console.log(error)
      }
    },
    handleAddCard() {
      this.visible = true
      this.$nextTick(async () => {
        this.processInstance = await this.$sdk.processBindCard({
          container: "#bind-card-container",
          cardBrand: "VISA_OR_MASTER",
          onSuccess: () => {
            this.visible = false
            this.initStatus()
            this.getCardList()
            this.$message({
              message: this.$t("checkout.bindCardSuccess"),
              type: "success"
            })
          },
          onError: err => {
            this.visible = false
            this.initStatus()
            this.$message({
              message: err,
              type: "error"
            })
          }
        })
      })
    },
    async getCardList() {
      this.loading = true
      try {
        const data = await this.$sdk?.getBindCardList()
        this.cardList = data || []
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleDelete(item) {
      this.$messageBox
        .open({
          title: this.$t("card.deleteCard"),
          message: this.$t("card.confirmText"),
          cancelText: this.$t("card.cancel"),
          confirmText: this.$t("card.confirm")
        })
        .then(res => {
          this.unbindCard(item)
        })
        .catch(res => {})
    },
    async unbindCard(item) {
      this.loading = true
      try {
        const data = await this.$sdk.unBindCard({
          signNum: item.signNum,
          paymentMethod: item.paymentMethod
        })
        await this.getCardList()
        if (data) this.$message.success(this.$t("card.message"))
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
